import React from 'react';
import { motion } from 'framer-motion';
import { colors } from '@keen.io/colors';
import { Icon } from '@keen.io/icons';
import { DownArrow, Container } from './sort-indicators.styles';
export var SortIndicators = function (_a) {
    var _b = _a.sortMode, sortMode = _b === void 0 ? 'ascending' : _b;
    return (React.createElement(Container, { "data-testid": "sort-indicators" },
        React.createElement(motion.div, { initial: { opacity: 0 }, animate: {
                opacity: sortMode === 'ascending' ? 1 : 0.3,
            } },
            React.createElement(Icon, { type: "arrow-up", fill: colors.white[500], width: 10 })),
        React.createElement(DownArrow, { initial: { opacity: 0 }, animate: {
                opacity: sortMode === 'descending' ? 1 : 0.3,
            } },
            React.createElement(Icon, { type: "arrow-down", fill: colors.white[500], width: 10 }))));
};
export default SortIndicators;
